export const getBogusValue = (number) => {
  if (number && number >= 0) {
    return '0'.repeat(number.toString().length);
  }
  return '0';
};
